import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, unref as _unref, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0d69ee75"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex justify-content-between h-800px" }
const _hoisted_2 = { class: "card overflow-auto" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Source")
], -1))
const _hoisted_4 = { class: "card-body" }
const _hoisted_5 = { class: "d-flex align-items-center justify-content-center" }
const _hoisted_6 = { class: "card overflow-auto" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "card-header" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "card-title" }, "Target")
], -1))
const _hoisted_8 = { class: "card-body" }
const _hoisted_9 = { class: "d-flex gap-20" }

import { ref, onMounted } from "vue";
import SimpleForm from "@/components/SimpleForm.vue";
import SystemService from "../services/SystemService";
import { ArrowRight } from "@element-plus/icons-vue";
import MsgPrompt from "@/components/MsgPrompt.vue";

export default /*#__PURE__*/_defineComponent({
  __name: 'AddGroup',
  emits: ["submit"],
  setup(__props, { expose: __expose, emit: emits }) {

const isLoading = ref(false);
const modalRef = ref<InstanceType<typeof SimpleForm>>();
const targetData = ref(<any>[]);
const sourceData = ref(<any>[]);
const title = ref("");


const submit = async () => {
  isLoading.value = true;
  try {
    emits("submit");
    // const res = await SystemServices.updateGroups({
    //   description: title.value,
    //   groups: targetData.value
    //     .filter((i: any) => i.toggle)
    //     .map((i: any) => i.name),
    // });
    // if (res) {
    //   emits("submit");
    //   hide();
    // }
  } catch (e) {
    console.log(e);
  }
  isLoading.value = false;
};
const show = (item: any) => {
  title.value = item.description;
  targetData.value = [];
  sourceData.value = [];
  item.groups.forEach((group: any) => {
    targetData.value.push({
      name: group,
      toggle: true,
    });
  });
  item.groups.forEach((group: any) => {
    sourceData.value.push({
      name: group + " Source",
      toggle: true,
      source: true,
    });
  });
  modalRef.value?.show();
};
const remove = (_item: any) => {
  const item = targetData.value.find((i: any) => i.name === _item.name);
  if (item) {
    item.toggle = false;
  }
};
const add = (item: any) => {
  const _item = sourceData.value.find((i: any) => i.name === item.name);
  if (_item) {
    _item.toggle = false;
  }
  targetData.value.unshift({
    name: item.name,
    toggle: true,
    source: item.source,
  });
};

const restore = (_item: any) => {
  const item = targetData.value.find((i: any) => i.name === _item.name);
  if (item) {
    item.toggle = true;
  }
};

const hide = () => {
  modalRef.value?.hide();
};

__expose({
  show,
  hide,
});

return (_ctx: any,_cache: any) => {
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_button = _resolveComponent("el-button")!
  const _component_el_table = _resolveComponent("el-table")!

  return (_openBlock(), _createBlock(SimpleForm, {
    ref_key: "modalRef",
    ref: modalRef,
    title: title.value,
    "is-loading": isLoading.value,
    submit: submit,
    "before-close": hide,
    width: 950,
    overflow: true
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _hoisted_3,
          _createElementVNode("div", _hoisted_4, [
            _createVNode(_component_el_table, {
              data: sourceData.value,
              class: "w-350px"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_table_column, {
                  prop: "name",
                  label: "Group",
                  width: "250"
                }),
                _createVNode(_component_el_table_column, null, {
                  default: _withCtx((scope) => [
                    _createVNode(_component_el_button, {
                      type: "success",
                      disabled: !scope.row.toggle,
                      onClick: ($event: any) => (add(scope.row))
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(" Add ")
                      ]),
                      _: 2
                    }, 1032, ["disabled", "onClick"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 8, ["data"])
          ])
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_el_button, {
            size: "large",
            icon: _unref(ArrowRight)
          }, null, 8, ["icon"])
        ]),
        _createElementVNode("div", _hoisted_6, [
          _hoisted_7,
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("div", _hoisted_9, [
              _createVNode(_component_el_table, {
                data: targetData.value,
                class: "w-350px"
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_el_table_column, {
                    label: "Group",
                    width: "220"
                  }, {
                    default: _withCtx((scope) => [
                      _createElementVNode("span", {
                        class: _normalizeClass([
                      scope.row.source ? 'text-success' : '',
                      scope.row.toggle ? '' : 'text-decoration-line-through',
                    ])
                      }, _toDisplayString(scope.row.name), 3)
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_el_table_column, null, {
                    default: _withCtx((scope) => [
                      (scope.row.toggle)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "danger",
                            onClick: ($event: any) => (remove(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Remove ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "warning",
                            onClick: ($event: any) => (restore(scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode(" Restore ")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }, 8, ["data"])
            ])
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["title", "is-loading"]))
}
}

})